import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { PageAlert } from "capitalrx-components";
import { TransmissionTypes } from "@/types";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { transmissionTestActions } from "@/App/actions";

function* transmissionTest(payload: TransmissionTypes.TransmissionData): Generator {
  return yield apiService({
    url: "/transmission/test",
    method: "POST",
    data: payload,
  });
}

export function* transmissionTestWorker(action: ReturnType<typeof transmissionTestActions.submitTransmissionTest>): SagaIterator {
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;
  const { submitTransmissionTestResult } = transmissionTestActions;

  try {
    yield put(startSubmit(formName));
    const result = yield call(transmissionTest, payload);

    yield put(submitTransmissionTestResult(result));
    yield put(stopSubmit(formName));
  } catch (error) {
    const {
      data: { field_error_messages = "", message = "Processing Test Claim failed." } = {},
    } = error || {};

    yield put(showPageAlert({ show: true, type: "error", message: message }));
    yield put(stopSubmit(formName, field_error_messages));
  }
}

export default function* transmissionTestWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SUBMIT_TRANSMISSION_TEST, transmissionTestWorker);
}
